import React from 'react';
import { t } from '../../RI18n';
import notodosImage from '../../images/checklist_64_grey.png';
import './NoToDos.css';

class NoToDos extends React.Component {
  render() {
    if (this.props.items === 0) {
      return (

        <div className="notodos">
          <img className="notodos-icon" src={notodosImage} alt={t('todolist.no_todos')} />
          <br />
          <span>{t('todolist.no_todos')}</span>
        </div>
      );
    }

    return null;
  }
}

export default NoToDos;
